<template>
    <h2 class="hidden md:block mb-1 text-3xl font-bold">Le tue fatture</h2>
</template>